/* global toastr */
import React from 'react'
import { request } from '../smart_bps/lib/utils'
import { store } from '../index'
import AttrInput from '../smart_bps/lib/attr_input'
import { BaseAdminModelView } from './model_view'
import { wrapView } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/admin/base_view'

class UserAdminModelView extends BaseAdminModelView {
  constructor(props) {
    super(props)
    this.changePassword = this.changePassword.bind(this)
    this.loginAsUser = this.loginAsUser.bind(this)
  }

  get model_name() {
    return 'User'
  }

  getDeleteConfirmTitle() {
    return 'Удаление пользователя'
  }

  changePassword() {
    const that = this
    request({
      method: 'post',
      url: '/api/admin/user_change_password',
      data: {
        user_id: this.object_id,
        value: this.state.change_password_value,
      },
      success: (message) => {
        toastr.info(message)
        that.setState({ change_password_value: '' })
      },
      error: (data) => {
        toastr.error(data.detail)
      },
    })
  }

  loginAsUser() {
    const that = this
    request({
      method: 'get',
      url: `/api/auth/token_as_user/${this.object_id}`,
      success: (data) => {
        toastr.info('Добро пожаловать под выбранным пользователем')
        localStorage.setItem('auth_access_token', data.access_token)
        localStorage.setItem('auth_refresh_token', data.refresh_token)
        localStorage.setItem('auth_refresh_url', data.refresh_url)
        that.setState({ redirect_to: '/' }, () => {
          store.dispatch({ type: 'auth_authenticated', data })
        })
      },
    })
  }

  saveObject() {
    const that = this
    request({
      method: 'post',
      url: `/api/admin/${this.model_name}/${this.object_id}/update_object`,
      data: {
        new_data: this.state.form_data,
        old_data: this.state.form_data_initial,
      },
      success: (data) => {
        store.dispatch({ type: 'admin_list_clean' })
        if (data.form_data) {
          that.dataToState(data)
          toastr.success('Изменения сохранены')
          if (data.message) toastr.success(data.message)
        }
        if (data.errors) {
          that.setState({ form_errors: data.errors })
          const rolesLnk = that.state.form_data?.roles_lnk

          const hasApprover = rolesLnk.includes('approver')
          const requiredFields = ['Email', 'Фамилия', 'Имя']
          if (!hasApprover) requiredFields.unshift('Контрагент')
          toastr.warning(
            `Карточка не может быть сохранена. Заполните обязательные поля: ${requiredFields.join(
              ', '
            )}. Добавьте хотя бы одну роль.`,
            'Внимание'
          )
        }
      },
      error: (data) => {
        toastr.error('Ошибка сохранения', data)
      },
    })
  }

  renderContentRight() {
    if (this.object_id === 0) return null
    const perms = this.state.perms || []
    const that = this
    return (
      <div className="card mb-3">
        <div className="card-body p-3 pb-2">
          <h5 className="card-title">Операции</h5>
          <div className="card-text">
            {perms.includes('login_as_user') && (
              <div className="mb-3">
                <span onClick={this.loginAsUser} className="btn btn-primary">
                  Войти под пользователем
                </span>
              </div>
            )}
            {perms.includes('change_password') && (
              <div className="mb-3">
                <AttrInput
                  data_type="string"
                  name="password"
                  placeholder="Новый пароль"
                  onChange={(name, value) => that.setState({ change_password_value: value })}
                  value={this.state.change_password_value || ''}
                />
                <button className="btn btn-primary p-2 me-2 mt-1" onClick={this.changePassword}>
                  Поменять
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  hasPerm(perm) {
      return this.state.perms && this.state.perms.includes(perm)
    }

    renderContentLeftAction() {
      // Запрещаем удалять, если документ создают.
      const isCreate = this.state.id === 0
      return (
        <div className="card mb-3" key="actions">
          <div className="card-body p-2">
            <span className="btn btn-outline-primary waves-effect p-2 me-2" onClick={this.saveObject}>
              <span className="ti ti-xs ti-check me-1"></span>
              Сохранить
            </span>
            {!isCreate && this.hasPerm("delete") && (
              <button className="btn btn-outline-danger waves-effect p-2 me-2" onClick={this.deleteObject}>
                <span className="ti ti-xs ti-trash me-1"></span>
              Удалить</button>
            )}
          </div>
        </div>
      )
    }

  componentDidUpdate(prevProps, prevState, snapshot) {
    super.componentDidUpdate(prevProps, prevState, snapshot)
    this.contractorPositionAccess()
  }

  contractorPositionAccess() {
    let contractorField = document.querySelector('select[name="contractor_id"]')
    let positionField = document.querySelector('select[name="position_id"]')

    if (contractorField && positionField) {
      const rolesLnk = this.state.form_data?.roles_lnk
      const roleMembershipMap = {
        approver: "customer",
        case_owner: "contractor",
        applicant: "contractor"

      }
      contractorField = contractorField.closest('div.row')
      positionField = positionField.closest('div.row')


      if (rolesLnk) {
        if (rolesLnk.includes("admin")) {
          contractorField.style.display = ''
          positionField.style.display = ''
          return null
        }

        contractorField.style.display = 'none'
        positionField.style.display = 'none'

        rolesLnk.forEach(role => {
          if (role in roleMembershipMap && roleMembershipMap[role] === "customer") {
            positionField.style.display = ''
          }
          if (role in roleMembershipMap && roleMembershipMap[role] === "contractor") {
            contractorField.style.display = ''
          }
        })
      }
    }
  return null
  }
}

export default wrapView(UserAdminModelView, stateToProps)
